import { render, staticRenderFns } from "./SocialLink.vue?vue&type=template&id=60f0ff18&"
import script from "./SocialLink.vue?vue&type=script&lang=ts&"
export * from "./SocialLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports